<template>
    <div
        class="max-w-full flex flex-row items-center cursor-pointer"
        @click="changeSelect()"
    >
        <div
            class="w-6 h-6 border rounded-full flex items-center justify-center mr-2  transition-colors"
            :class="[
                modelValue ? 'border-' + activeColor : 'border-' + defaultColor,
            ]"
        >
            <div
                class="w-4 h-4  rounded-full flex items-center justify-center  transition-colors"
                :class="[modelValue ? 'bg-' + activeColor : 'bg-transparent']"
            />
        </div>
        <label
            class="cursor-pointer transition-colors select-none"
            :class="'text-' + defaultColor"
            :for="id"
            >{{ label }}</label
        >
    </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    components: {},
    name: "InputRadio",
    props: {
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: false,
        },
        modelValue: {
            type: Boolean,
            required: true,
        },
        label: {
            type: String,
            required: false,
        },

        defaultColor: {
            type: String,
            required: true,
        },
        activeColor: {
            type: String,
            required: true,
        },
    },
    emits: ["change"],
    setup(props, ctx) {
        /**
         * emits
         */
        function changeSelect() {
            ctx.emit("change", !props.modelValue);
        }

        return {
            //emits
            changeSelect,
        };
    },
});
</script>
<style lang="scss"></style>
